module.exports = __webpack_public_path__ + "img/case_2.68fbac15.svg";